/**
 * The row above a table: what narrows it, and what acts on it.
 *
 * A layout with no behaviour, and it exists because every list screen in the
 * application has this row and each one would otherwise invent its own
 * flex rules. It wraps on a narrow viewport instead of scrolling sideways,
 * because a search field pushed off-screen is a search field nobody uses.
 */

import type { ReactNode } from "react";

import "./layout.css";

export interface ToolbarProps {
  /** Search, filters — anything that narrows what is shown. */
  children?: ReactNode;
  /** Buttons that act on the list or create a new row. */
  actions?: ReactNode;
}

export function Toolbar({ children, actions }: ToolbarProps) {
  return (
    <div className="hardauto-toolbar">
      <div className="hardauto-toolbar__filters">{children}</div>
      {actions ? <div className="hardauto-toolbar__actions">{actions}</div> : null}
    </div>
  );
}
